import { AnimatePresence, motion } from "framer-motion";
import React, { memo } from "react";
import { useLocation } from "react-router-dom";

const pageAnimation = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
		transition: {
			duration: 0.25,
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.1,
		},
	},
};

const pageTransition = {
	type: "tween",
	ease: "easeInOut",
	duration: 0.4,
};

const wrapperStyle: React.CSSProperties = {
	position: "relative",
	width: "100%",
	flex: 1,
	minHeight: 0,
};

const defaultStyle: React.CSSProperties = {
	position: "absolute",
	top: 0,
	left: 0,
	width: "100%",
	height: "100%",
};

interface PageTransition {
	children?: React.ReactNode;
}

const PageTransition: React.FC<PageTransition> = ({ children }) => {
	const { pathname } = useLocation();

	return (
		<div key={pathname} style={wrapperStyle}>
			<AnimatePresence mode="wait">
				<motion.div
					initial="initial"
					animate="animate"
					exit="exit"
					variants={pageAnimation}
					transition={pageTransition}
					style={defaultStyle}
				>
					{children}
				</motion.div>
			</AnimatePresence>
		</div>
	);
};

export default memo(PageTransition);
